import { useState, useEffect } from "react";

import { translate } from "@utils";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

export const PolicyFormNameInput = ({ viewOnly = false, activePolicy, setActivePolicy }) => {
	const handleOnChange = (e) => {
		setActivePolicy((prevState) => ({ ...prevState, name: e.target.value }));
	};
	return (
		<FormControl style={{ width: "50%", paddingRight: "30px" }}>
			<TextField disabled={viewOnly} id="cvePolicyForm-name" label={translate("cve_policyName_label")} value={activePolicy.name || ""} onChange={handleOnChange} variant="filled" />
		</FormControl>
	);
};
